import React, { useState, useRef, useEffect } from "react";
import Constants from "../../constants/Constants";
import useInterval from "../../hooks/useInterval";
import { useTheme } from "../../context/theme.context";
import { navigate, Link } from "@reach/router";
import "../../css/search.css";

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? "active" : "",
      };
    }}
  />
);
const Header = ({
  userInfo,
  snapchat,
  toggleFilters,
  showFilters,
  search,
  unreadMsgs,
}) => {
  const flatModels = Object.keys(search).map((key) => {
    return { site_name: search[key].site_name, site_url: search[key].site_url };
  });
  const themeState = useTheme();
  const [showProfile, setShowProfile] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [profileActive, setProfileActive] = useState(false);
  const theSearchInput = useRef(null);
  useEffect(() => {
    if (searchShow) {
      setTimeout(() => theSearchInput.current.focus(), 222);
    }
  }, [searchShow]);
  const handleSearchSelect = (item) => {
    navigate(`${Constants.MA}${item.url}`, {
      state: {
        hasBack: true,
      },
    });
    setSearchResults([]);
    setSearchTerm("");
    setSearchShow(false);
  };

  const handleSearching = (e) => {
    const newSearchTerm = e.target.value.toLowerCase();
    setSearchTerm(newSearchTerm);
    setSearchResults(
      flatModels
        .filter(
          (model) => model.site_name.toLowerCase().indexOf(newSearchTerm) !== -1
        )
        .map((model) => {
          const l = newSearchTerm.length;
          const w = model.site_name.length;
          const s = model.site_name.toLowerCase().indexOf(newSearchTerm);
          return {
            modelName: model.site_name,
            start: s,
            end: l,
            whole: w,
            url: model.site_url,
          };
        })
    );
  };
  const toggleSearch = () => {
    setSearchShow(!searchShow);
  };
  useInterval(
    () => {
      setShowProfile(false);
    },
    showProfile && profileActive ? null : showProfile ? 2000 : null
  );
  const handleShowProfile = () => {
    setShowProfile(!showProfile);
  };
  return (
    <div className={searchShow ? "header searchView" : "header"} id="header">
      <div className="header_logo">
        <Link to={`${Constants.MA}subscriptions`}>
          <em>+</em>Add<strong>Friends</strong>.com
          <span>members area</span>
        </Link>
      </div>
      <div className="stretch_wrapper">
        <div className="header_navigation">
          <div className="item">
            <NavLink to={`${Constants.MA}af-now`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="19"
                viewBox="0 0 22 19"
              >
                <g>
                  <g>
                    <path
                      fill="#8a8a8a"
                      d="M10.451 9.467h-6.65L2.345 12.76h-.9L6.717 1.063h.836l5.274 11.696h-.901zm-.31-.718L7.127 2 4.13 8.749zm5.85-5.514v3.091h5.307V8.5H15.99v4.26h-2.654V1.063H22v2.172zM4.752 2.697h-2.03v2.027h-.688V2.697H.002V2.04h2.032V0h.687V2.04h2.031zm.392 11.616c.572 0 1.027.168 1.363.506.337.338.506.833.506 1.486v2.642h-.816V16.4c0-.444-.104-.78-.314-1.005-.21-.225-.51-.338-.9-.338-.442 0-.79.132-1.045.395-.254.263-.382.64-.382 1.13v2.365H2.74v-4.591h.781v.693c.164-.237.386-.419.667-.546.28-.127.599-.19.955-.19zm5.59 4.686c-.446 0-.848-.1-1.205-.303a2.18 2.18 0 0 1-.837-.836 2.41 2.41 0 0 1-.301-1.209c0-.45.1-.853.301-1.208.202-.355.48-.633.837-.832a2.431 2.431 0 0 1 1.206-.299c.447 0 .848.1 1.202.3.354.198.632.476.832.83.2.356.301.759.301 1.21 0 .45-.1.853-.3 1.208a2.18 2.18 0 0 1-.833.836 2.379 2.379 0 0 1-1.202.303zm0-.727c.29 0 .549-.068.778-.204.23-.135.409-.326.54-.572.13-.245.194-.527.194-.845 0-.317-.064-.599-.195-.844a1.4 1.4 0 0 0-.539-.568 1.524 1.524 0 0 0-.777-.199c-.289 0-.548.067-.777.2-.23.132-.41.322-.544.567-.133.245-.2.527-.2.844 0 .318.067.6.2.845a1.45 1.45 0 0 0 1.32.776zm10.344-3.916l-1.682 4.591h-.78l-1.3-3.482-1.317 3.482h-.78l-1.674-4.591h.773l1.308 3.656 1.358-3.656h.689l1.333 3.673 1.341-3.673z"
                    />
                  </g>
                </g>
              </svg>
              <span className="af_text">AF now</span>
            </NavLink>
          </div>
          <div className="item">
            <NavLink to={`${Constants.MA}favorites`}>
              <i className="icon-empty-heart" />
              <span>Favorites</span>
            </NavLink>
          </div>
          <div className="item">
            <NavLink to={`${Constants.MA}subscriptions`}>
              <i className="icon-fav" />
              <span>subscriptions</span>
            </NavLink>
          </div>
          <div className="item">
            <NavLink to={`${Constants.MA}friends`}>
              <i className="icon-models" />
              <span>Friends</span>
            </NavLink>
          </div>
        </div>
        <div className="search_header">
          <form action="#">
            <div className="columns">
              <div className="column second">
                <button type="submit" className="button">
                  <i className="icon-search" />
                </button>
              </div>
              <div className="column">
                <input
                  type="text"
                  ref={theSearchInput}
                  className="input"
                  id="input"
                  onChange={handleSearching}
                  placeholder="Search"
                  autoFocus
                  value={searchTerm}
                />
              </div>
              <div className="column second" onClick={toggleSearch}>
                <button type="button" className="button" id="buttonSearchClose">
                  <i className="icon-close" />
                </button>
              </div>
              {searchShow && searchResults.length > 0 ? (
                <div className="autocomplete-suggestions">
                  {searchResults.map((item, i) => (
                    <div className="autocomplete-suggestion" key={`srr${i}`}>
                      {item.start === 0 ? (
                        <div onClick={() => handleSearchSelect(item)}>
                          <b>{item.modelName.slice(0, item.end)}</b>
                          {item.modelName.slice(item.end)}
                        </div>
                      ) : (
                        <div onClick={() => handleSearchSelect(item)}>
                          {item.modelName.slice(0, item.start)}
                          <b>
                            {item.modelName.slice(
                              item.start,
                              item.start + item.end
                            )}
                          </b>
                          {item.modelName.slice(item.start + item.end)}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </form>
        </div>
      </div>
      <div className="header_aside">
        <div className="block_second" onClick={toggleSearch}>
          <button type="button" className="button_search" id="buttonSearch">
            <i className="icon-search" />
          </button>
        </div>
        {/* <div className="block_second">
          <button
            type="button"
            className={showFilters ? "button_setting open" : "button_setting"}
            id="buttonFilter"
            onClick={toggleFilters}
          >
            <i className="icon-set" />
          </button>
        </div> */}
        <div
          className={showProfile ? "block_second view_drop" : "block_second"}
        >
          <button
            type="button"
            className="button_profile"
            id="buttonProfileView"
          >
            <div className="avatar" onClick={handleShowProfile}>
              <img
                src={`${Constants.AVATAR_URL}${userInfo.avatar}.jpg`}
                alt=""
              />
            </div>
          </button>
          {unreadMsgs > 0 ? (
            <div className="unread desktop">{unreadMsgs}</div>
          ) : null}
          <div
            className="dropped_profile"
            onMouseEnter={() => setProfileActive(true)}
            onMouseLeave={() => setProfileActive(false)}
          >
            <div className="heading">
              <div className="avatar">
                <img
                  src={`${Constants.AVATAR_URL}${userInfo.avatar}.jpg`}
                  alt=""
                />
              </div>
              <div className="inform">
                <div className="nickname">
                  <strong>{snapchat}</strong>
                </div>
                <div className="email">{userInfo.username}</div>
              </div>
            </div>
            <div className="list">
              <div className="row">
                <div className="item">
                  <Link to={`${Constants.MA}messages`}>
                    <i className="icon-email" />
                    <span>Messages</span>
                  </Link>
                </div>
                <div className="item">
                  <Link to={`${Constants.MA}profile`}>
                    <i className="icon-user" />
                    <span>Profile</span>
                  </Link>
                </div>
                <div className="item" onClick={themeState.toggle}>
                  <span>
                    <i className="icon-moon" />
                    <span>Dark theme: {themeState.dark ? "On" : "Off"}</span>
                  </span>
                </div>
                <div className="item">
                  <Link to={`${Constants.MA}what-is-premium`}>
                    <i className="icon-question-circle" />
                    <span>Help</span>
                  </Link>
                </div>
              </div>
              <div className="row">
                <div className="item">
                  <a href="https://addfriends.com/logout">
                    <i className="icon-exit" />
                    <span>Logout</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
